<script setup lang="ts">
import Button from '@/core/components/base/Button.vue'
import LanguageView from '@/core/components/LanguageView.vue'
import { useLanguage } from '@/core/composables/useLanguage'
import { useButtonTranslate } from './ButtonTranslate'

const { show, disabled, doPopupTranslateOpen } = useButtonTranslate()
const { currentLang } = useLanguage()

function handleTap(event: PointerEvent) {
  doPopupTranslateOpen()
}
</script>

<template>
  <LanguageView lang="th">
    <Button v-show="show" class="button-translate" :disabled @tap="handleTap">
      <template #default><img src="/images/simakatra/th/button-translate.png" /></template>
      <template #disabled><img src="/images/simakatra/th/button-translate-disable.png" /></template>
    </Button>
  </LanguageView>

  <LanguageView lang="en">
    <Button v-show="show" class="button-translate en" :disabled @tap="handleTap">
      <template #default><img src="/images/simakatra/en/button-translate.png" /></template>
      <template #disabled><img src="/images/simakatra/en/button-translate-disable.png" /></template>
    </Button>
  </LanguageView>
</template>

<style scoped>
.button-translate {
  position: absolute;
  left: 1086px;
  top: 989px;
}

.button-translate.en {
  left: 1048px;
}
</style>
